import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import ProductSelector from "@/components/landing/ProductSelector";
import Wholesale from "@/components/landing/Wholesale";
import Comparison from "@/components/landing/Comparison";
import Calculator from "@/components/landing/Calculator";
import CtaBanner from "@/components/landing/CtaBanner";
import Advantages from "@/components/landing/Advantages";
import Applications from "@/components/landing/Applications";
import Downloads from "@/components/landing/Downloads";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

function LandingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Wholesale />
        <ProductSelector />
        <Comparison />
        <Calculator />
        <CtaBanner />
        <Advantages />
        <Applications />
        <Downloads />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
